let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j4wHZ")).then(() => parcelRequire('5Tbea'));